import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ClinicApi } from '@core/apis/clinic/clinic.api';
import { getSubdomainPart } from '@core/services/get-subdomain';
import { ClinicStore } from '@core/stores/clinic.store';
import { catchError, of, switchMap } from 'rxjs';

export const canActivateClinic: CanActivateFn = () => {
  const clinicApi = inject(ClinicApi);
  const router = inject(Router);
  const clinicStore = inject(ClinicStore);

  return clinicApi.getSubDomain(getSubdomainPart()).pipe(
    switchMap((clinic) => {
      if (clinic) {
        clinicStore.set(clinic);
        return of(true);
      } else {
        router.navigate(['/error']);
        return of(false);
      }
    }),
    catchError(() => {
      router.navigate(['/error']);
      return of(false);
    }),
  );
};
